module.exports = __webpack_public_path__ + "img/modal3.fd322bad.jpg";